<template>
  <div class="layout">
    <router-view />
    <Head />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Head from "./Head";
export default {
  name: "Layout",
   components: {
    Head,
  },
  data() {
    return {
      input21: "",
    };
  },
  methods: {
    openCity(evt, path) {
      /*
      console.log(evt.currentTarget);
      this.$router.push({
        path,
      });
      */
      let i, tabcontent, tablinks;
      /*
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      */
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      // document.getElementById(path).style.display = "block";
      evt.currentTarget.className += " active";
    },
  },
};
</script>
<style scoped>
.layout{
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue